import React, { Fragment, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { translate } from 'react-i18next'
import VideoSliderControls from '../VideoSliderControls'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Loader from '../Loader'
import { CaseFlow } from '../CaseFlow'
import VoiceItem from '../VoiceItem'
import AudioComponent from '../AudioComponent'
import VideoPlayer from '../VideoPlayer'
import SimpleLink from '../SimpleLink'
import { Routes } from '../../utils/constants'
import { CasesSlider } from '../CasesSlider'
import { pages } from '../../utils/constants'
import { withRouter } from 'react-router-dom'
import './index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const Cases = ({
  t,
  lng,
  actions: {
    getCases,
    toggleFavoriteVoice,
    changeModalVisibility,
    setPlayList,
    toggleVisibleAudioPlayer,
    setPlayingStatus,
    setPlayingVoiceId,
    setChoosenVoice,
  },
  cases,
  loading,
  currentVoiceId,
  isAudioPlaying,
  isAudioVisible,
  history,
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const activeCase = cases[activeIndex]

  useEffect(() => {
    if (!cases.length) {
      getCases()
    }
  }, [cases, getCases])

  useEffect(() => {
    if (activeCase && activeCase.audio.length) {
      setPlayList(activeCase.audio)
    }
	}, [cases, setPlayList, activeCase])

  const handleBack = () => {
    const path = lng === 'en' ? `/${pages.WORK}` : `/${lng}/${pages.WORK}`
    history.push(path)
	}
	
	const slides = cases.map(el => ({ thumbnailUrl: el.thumbnailUrl, id: el.id }))

  return (
    <>
      <Helmet>
        <html lang={lng} />
        <title>{t('meta.work.title')}</title>
        <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/portfolio/cases" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/portfolio/cases" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/portfolio/cases" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/portfolio/cases" />
        <meta name="description" content={t('meta.work.descr')} />
        {lng === 'en' && <meta name="keywords" content={t('meta.work.keywords')} />}
        {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/portfolio/cases'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/portfolio/cases`} />}
        <meta property="og:title" content={t('meta.work.title')} />
        <meta property="og:description" content={t('meta.work.descr')} />
        <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
        <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/portfolio/cases': `https://unimedia.io/${lng}/portfolio/cases`} />
        <script type="application/ld+json">
        {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.about.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.portfolio')}",
                "item": "https://unimedia.io/portfolio"
              },{
                "@type": "ListItem",
                "position": 3,
                "name": "${t('portfolio.links.cases')}"
              }]
            }]`}
          </script>
      </Helmet>
      <ScrollUpButton id={'cases'} />
      <div className="cases-page container overflow-y" id={'cases'}>
        <div className="container-wrapper">
        <Breadcrumbs pathname={window.location.pathname} color={'white'}/>
          {/* <button onClick={handleBack} className="btn btn-back subtitle-2">
            {t('general.back')}
          </button> */}
          <h3>{t('cases.title')}</h3>
          {!cases.length || loading ? (
            <Loader />
          ) : (
            <>
              <div className="case-descr-wrapper">
                <img width="150" height="150" alt="img" src={activeCase.thumbnailUrl} />
                <VideoSliderControls
                  handleChangePrevSlide={() => setActiveIndex(activeIndex - 1)}
                  activeSlide={activeIndex}
                  handleChangeNextSlide={() => setActiveIndex(activeIndex + 1)}
                  totalSlides={cases.length - 1}
                />
                <div className="case-descr">
                  <h5>{activeCase.caseName}</h5>
                  <p className="body-light">{t(`cases.${activeCase.caseCountry}`)}</p>
                  {activeCase.caseDescr.map((text, ind) => (
                    <p key={ind} className="body-light">
                      {t(`cases.${text}`)}
                    </p>
                  ))}
                </div>
              </div>

              <CaseFlow caseTask={activeCase.caseTask} />

              <ul className="voices-list">
                {activeCase.audio && activeCase.audio.map(audio => (
                  <VoiceItem
                    key={audio.id}
                    changeModalVisibility={changeModalVisibility}
                    voiceItem={audio}
                    toggleFavoriteVoice={toggleFavoriteVoice}
                    toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                    setPlayingStatus={setPlayingStatus}
                    currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
                    setPlayingVoiceId={setPlayingVoiceId}
                    setChoosenVoice={setChoosenVoice}
                    hasVoiceSescr={false}
                  />
                ))}
                <SimpleLink
                  route={lng === 'en' ? Routes.VOICES : `/${lng}${Routes.VOICES}`}
                  text={t('navigations.moreVoices')}
                />
              </ul>

              <div className="case-video">
                {activeCase.video && activeCase.video.map((video, ind) => (
                  <Fragment key={ind}>
                    <p className="body-light">{t(`cases.${video.title}`)}</p>
                    <VideoPlayer videoUrl={video.videoUrl} thumbUrl={video.thumb} />
                  </Fragment>
                ))}

                <SimpleLink
                  route={lng === 'en' ? Routes.SHOWREELS : `/${lng}${Routes.SHOWREELS}`}
                  text={t('navigations.moreVideo')}
                />
              </div>
            </>
          )}
          {isAudioVisible && <AudioComponent />}
        </div>
        <CasesSlider
          slides={slides}
          handleChangeSlide={setActiveIndex}
          activeIndex={activeIndex}
        />
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  cases: state.cases,
  loading: state.app.loading,
  isAudioVisible: state.audioPlayer.isVisible,
  currentVoiceId: state.audioPlayer.currentVoiceId,
  isAudioPlaying: state.audioPlayer.isPlaying,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(Cases))
)
